var codeblock_default = {
  "blockStyleSpacing": "o-Ld6",
  "codeBlock": "UEayN o-Ld6",
  "renderedInTable": "TaOVE"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
